import { Agent, QueueResponse } from "@/contexts/AppDataContext";
import { CallQueueType } from "@/constants/queue";

/**
 * Get available agents based on selected queues and queue type
 */
export const getAvailableAgents = (
  selectedQueues: string[],
  selectedQueueType: CallQueueType | null,
  queuesResponse: QueueResponse[],
  uniqueAgents: Agent[]
): Agent[] => {
  if (selectedQueues.length === 0) {
    // If no queue is selected, return all agents matching the queue type
    return uniqueAgents.filter(agent => agent.queueType === selectedQueueType);
  }

  // Return agents that belong to selected queues
  const queueAgents = queuesResponse
    .filter(queue => 
      selectedQueues.includes(
        queue.type === CallQueueType.CALL_QUEUE 
          ? queue.microsoftId 
          : queue.id?.toString() || ""
      )
    )
    .flatMap(queue => queue.agents || []);

  // Remove duplicates by microsoftId
  return Array.from(
    new Map(queueAgents.map((agent) => [agent.microsoftId, agent])).values()
  );
};

/**
 * Get agent Microsoft IDs from available agents
 */
export const getAgentIds = (availableAgents: Agent[]): string[] => {
  return availableAgents.map(agent => agent.microsoftId);
};
